<template>
  <div id="test">
    <div class="row">
      <div class=" col-12 px-0 pb-4">
        <GmapMap
            :center='{lat: markers[0].position.lat, lng:  markers[0].position.lng}'
            :options="{
                   zoomControl: true,
                   mapTypeControl: false,
                   scaleControl: false,
                   streetViewControl: false,
                   rotateControl: false,
                   fullscreenControl: false,
                   disableDefaultUi: false,
                      }"
            :zoom='12'
            style='width:100%;  height: 220px;'>
          <GmapMarker
              v-for="(m, index) in markers"
              :key="index"
              :icon="{ url: m.icon,
                scaledSize: { width: 45, height: 45}   }"
              :position="m.position"/>

        </GmapMap>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PostsMap",
  props: ['markers'],
  data: () => ({
    vendorDetailModal: false,
    searchKeyWord: null,
    center: {lat: 35.699936, lng: 51.390377},
    text: "",
    currentPlace: null,
    date: null,
    description: null,
    name: null,
    id: null,
    isDetailLoaded: false,
  }),

}
</script>
<style>
.gm-style img[src^="https://pwa.eyvankhaneh.app"] {
  border-radius: 50% !important;
}
</style>

